import { gql } from "@apollo/client";

export const GET_DOCUMENTO_DETALLE = gql`
query GetDocumentosDetalle($idEvaluacion: Int!, $fechaDesde: String!, $fechaHasta: String!, $documentos: String!) {
    documentosDetalle(idEvaluacion: $idEvaluacion, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, documentos: $documentos) {
      success,
      error,
      valorEsperado
    }
  }`;